/**
 * Countdown Sale Timer Component
 * Displays a countdown timer that persists across page refreshes within the same session
 */
class CountdownSaleTimer extends HTMLElement {
    constructor() {
        super();
        this.productId = this.dataset.productId;
        this.timerMinutes = parseInt(this.dataset.timerMinutes) || 10;
        this.storageKey = `countdown-timer-${this.productId}`;
    }

    connectedCallback() {
        this.minutesEl = this.querySelector('[data-minutes]');
        this.secondsEl = this.querySelector('[data-seconds]');

        this.initTimer();
        this.startCountdown();
    }

    disconnectedCallback() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

    initTimer() {
        // Get stored end time or create new one
        let endTime = sessionStorage.getItem(this.storageKey);

        if (!endTime || parseInt(endTime) <= Date.now()) {
            // Create new end time based on configured minutes
            endTime = Date.now() + (this.timerMinutes * 60 * 1000);
            sessionStorage.setItem(this.storageKey, endTime);
        }

        this.endTime = parseInt(endTime);
    }

    startCountdown() {
        // Update immediately
        this.updateDisplay();

        // Update every second
        this.intervalId = setInterval(() => {
            this.updateDisplay();
        }, 1000);
    }

    updateDisplay() {
        const now = Date.now();
        const remaining = Math.max(0, this.endTime - now);

        if (remaining <= 0) {
            // Timer expired - reset with new time
            this.endTime = Date.now() + (this.timerMinutes * 60 * 1000);
            sessionStorage.setItem(this.storageKey, this.endTime);
            this.classList.remove('m-countdown-sale-timer--urgent');
            return;
        }

        // Calculate minutes and seconds
        const totalSeconds = Math.floor(remaining / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        // Update display
        if (this.minutesEl) {
            this.minutesEl.textContent = String(minutes).padStart(2, '0');
        }
        if (this.secondsEl) {
            this.secondsEl.textContent = String(seconds).padStart(2, '0');
        }

        // Add urgency class when less than 2 minutes
        if (totalSeconds < 120) {
            this.classList.add('m-countdown-sale-timer--urgent');
        } else {
            this.classList.remove('m-countdown-sale-timer--urgent');
        }
    }
}

// Define the custom element
if (!customElements.get('countdown-sale-timer')) {
    customElements.define('countdown-sale-timer', CountdownSaleTimer);
}
